import {createContext} from 'react'

import {ChangeableFields, ConfirmationState} from '../types'

export type ChangeableFieldContextProps = {
  /** Base changeable fields from configuration only (time-based rules) */
  baseChangeableFields: ChangeableFields
  /** Changeable fields with Order Change rules applied (spacing, material, order confirmation) */
  orderChangeRulesOnlyChangeableFields: ChangeableFields
  /** Final changeable fields with all rules applied (including slot management) */
  changeableFields: ChangeableFields
  /** Confirmation state based on final changeable fields */
  confirmationState: ConfirmationState
}

export const ChangeableFieldContext = createContext<ChangeableFieldContextProps | undefined>(
  undefined
)
